"use client";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
  Stack,
} from "@chakra-ui/react";
import React from "react";

export interface FAQSectionProps {
  title: string;
  faqs: Array<{
    __typename: "GCMS_Faq";
    id: string;
    question: string;
    answer: React.ReactNode;
  }>;
  bg: string;
  color: string;
}

export default function FAQSection({
  title,
  faqs,
  bg,
  color,
}: FAQSectionProps) {
  return (
    <Box as="section" bg={bg} color={color}>
      <Stack
        maxW="2xl"
        mx="auto"
        px={{ base: "6", lg: "8" }}
        py={{ base: "16", sm: "20" }}
        spacing={{
          base: "6",
          lg: "12",
        }}
        textAlign="center"
      >
        <Heading as="h2" size="3xl" fontWeight="bold" letterSpacing="tight">
          {title}
        </Heading>

        <Accordion allowToggle textAlign="left">
          {faqs.map((faq) => (
            <AccordionItem key={faq.id}>
              <h2>
                <AccordionButton
                  _expanded={{
                    fontWeight: "bold",
                    bg: "blueGray.50",
                  }}
                  _focus={{
                    outline: "none",
                  }}
                  _hover={{
                    bg: "blueGray.50",
                  }}
                >
                  <Box flex="1" textAlign="left" fontSize="lg">
                    {faq.question}
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel
                pb={4}
                sx={{
                  p: {
                    mb: "4",
                  },
                }}
              >
                {faq.answer}
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Stack>
    </Box>
  );
}
